/******/ (() => { // webpackBootstrap
/******/ 	var __webpack_modules__ = ({

/***/ "./src/js/main.js":
/*!************************!*\
  !*** ./src/js/main.js ***!
  \************************/
/***/ (() => {

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i["return"] && (_r = _i["return"](), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e2) { throw _e2; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e3) { didErr = true; err = _e3; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _wrapNativeSuper(Class) { var _cache = typeof Map === "function" ? new Map() : undefined; _wrapNativeSuper = function _wrapNativeSuper(Class) { if (Class === null || !_isNativeFunction(Class)) return Class; if (typeof Class !== "function") { throw new TypeError("Super expression must either be null or a function"); } if (typeof _cache !== "undefined") { if (_cache.has(Class)) return _cache.get(Class); _cache.set(Class, Wrapper); } function Wrapper() { return _construct(Class, arguments, _getPrototypeOf(this).constructor); } Wrapper.prototype = Object.create(Class.prototype, { constructor: { value: Wrapper, enumerable: false, writable: true, configurable: true } }); return _setPrototypeOf(Wrapper, Class); }; return _wrapNativeSuper(Class); }
function _construct(Parent, args, Class) { if (_isNativeReflectConstruct()) { _construct = Reflect.construct.bind(); } else { _construct = function _construct(Parent, args, Class) { var a = [null]; a.push.apply(a, args); var Constructor = Function.bind.apply(Parent, a); var instance = new Constructor(); if (Class) _setPrototypeOf(instance, Class.prototype); return instance; }; } return _construct.apply(null, arguments); }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _isNativeFunction(fn) { return Function.toString.call(fn).indexOf("[native code]") !== -1; }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, defineProperty = Object.defineProperty || function (obj, key, desc) { obj[key] = desc.value; }, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return defineProperty(generator, "_invoke", { value: makeInvokeMethod(innerFn, self, context) }), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == _typeof(value) && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; defineProperty(this, "_invoke", { value: function value(method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; } function maybeInvokeDelegate(delegate, context) { var methodName = context.method, method = delegate.iterator[methodName]; if (undefined === method) return context.delegate = null, "throw" === methodName && delegate.iterator["return"] && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method) || "return" !== methodName && (context.method = "throw", context.arg = new TypeError("The iterator does not provide a '" + methodName + "' method")), ContinueSentinel; var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, defineProperty(Gp, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), defineProperty(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (val) { var object = Object(val), keys = []; for (var key in object) keys.push(key); return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, "catch": function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
// Load More functionality for collection pages
document.addEventListener('alpine:init', function () {
  Alpine.data('LoadMore', function () {
    // Non-reactive state to avoid Alpine reactivity edge-cases
    var internalCurrentPage = 1;
    return {
      loading: false,
      hasMore: true,
      currentPage: 1,
      totalPages: 1,
      nextUrl: '',
      loadMoreLimit: 24,
      buttonText: 'show me more!',
      init: function init(nextUrl, loadMoreLimit, totalPages, currentPage) {
        var _this = this;
        this.nextUrl = nextUrl;
        this.loadMoreLimit = loadMoreLimit;
        this.totalPages = totalPages;
        internalCurrentPage = currentPage;
        // Keep reactive mirror for external code that may read it, but do not mutate it later
        this.currentPage = currentPage;
        this.hasMore = internalCurrentPage < totalPages;

        // Update button text based on remaining pages
        this.updateButtonText();

        // Listen for filterable updates to reset load more state
        this.handleFilterableUpdate = function (event) {
          _this.resetLoadMoreState();
        };
        document.addEventListener('filterable:updated', this.handleFilterableUpdate);
      },
      resetLoadMoreState: function resetLoadMoreState() {
        var _this2 = this;
        // Reset to initial state when filters/sorting is applied
        this.loading = false;

        // Wait for the DOM to update after filtering, then extract new pagination info
        setTimeout(function () {
          var loadMoreButton = document.querySelector('[x-data*="LoadMore"]');
          if (loadMoreButton) {
            var xInitAttr = loadMoreButton.getAttribute('x-init');
            if (xInitAttr) {
              // Extract parameters from x-init attribute
              var urlMatch = xInitAttr.match(/init\('([^']+)'/);
              var limitMatch = xInitAttr.match(/,\s*(\d+)/);
              var totalPagesMatch = xInitAttr.match(/,\s*(\d+),\s*(\d+)\)/);
              if (urlMatch) {
                _this2.nextUrl = urlMatch[1];
              }
              if (limitMatch) {
                _this2.loadMoreLimit = parseInt(limitMatch[1]);
              }
              if (totalPagesMatch) {
                _this2.totalPages = parseInt(totalPagesMatch[1]);
                internalCurrentPage = parseInt(totalPagesMatch[2]) || 1;
                // Optional mirror update; do not increment later
                _this2.currentPage = internalCurrentPage;
                _this2.hasMore = internalCurrentPage < _this2.totalPages;
              }
              _this2.updateButtonText();
            }
          } else {
            // No load more button found, check if pagination exists
            var hiddenPagination = document.querySelector('[style*="display: none"] .pagination');
            if (hiddenPagination) {
              var nextLink = hiddenPagination.querySelector('a.theme-link:not(.theme-link--back)');
              if (nextLink && nextLink.getAttribute('href')) {
                _this2.hasMore = true;
                internalCurrentPage = 1;
                _this2.currentPage = internalCurrentPage;
                _this2.nextUrl = nextLink.getAttribute('href');

                // Try to extract total pages from pagination structure
                var pageNumbers = hiddenPagination.querySelectorAll('a[href*="page="], li[aria-current="page"]');
                if (pageNumbers.length > 0) {
                  var maxPage = 1;
                  pageNumbers.forEach(function (el) {
                    var pageText = el.textContent.trim();
                    var pageNum = parseInt(pageText);
                    if (!isNaN(pageNum) && pageNum > maxPage) {
                      maxPage = pageNum;
                    }
                  });
                  _this2.totalPages = maxPage;
                }
              } else {
                _this2.hasMore = false;
              }
            } else {
              _this2.hasMore = false;
            }
            _this2.updateButtonText();
          }
        }, 100); // Small delay to ensure DOM is updated
      },
      destroy: function destroy() {
        // Clean up event listener when component is destroyed
        if (this.handleFilterableUpdate) {
          document.removeEventListener('filterable:updated', this.handleFilterableUpdate);
        }
      },
      updateButtonText: function updateButtonText() {
        var remainingPages = this.totalPages - internalCurrentPage;
        if (remainingPages > 0) {
          this.buttonText = "show me more!";
        } else {
          this.buttonText = 'All Products Loaded';
        }
      },
      loadMore: function loadMore() {
        var _this3 = this;
        return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
          var response, html, parser, doc, newProductsContainer, currentProductsContainer, newProducts, hiddenPagination, nextLink, loadMoreButton, xInitAttr, urlMatch, totalPagesMatch;
          return _regeneratorRuntime().wrap(function _callee$(_context) {
            while (1) switch (_context.prev = _context.next) {
              case 0:
                if (!(_this3.loading || !_this3.hasMore)) {
                  _context.next = 2;
                  break;
                }
                return _context.abrupt("return");
              case 2:
                _this3.loading = true;
                _context.prev = 3;
                _context.next = 6;
                return fetch(_this3.nextUrl);
              case 6:
                response = _context.sent;
                if (response.ok) {
                  _context.next = 9;
                  break;
                }
                throw new Error("HTTP error! status: ".concat(response.status));
              case 9:
                _context.next = 11;
                return response.text();
              case 11:
                html = _context.sent;
                // Parse the response
                parser = new DOMParser();
                doc = parser.parseFromString(html, 'text/html'); // Find the product grid in the response
                newProductsContainer = doc.querySelector('#results ul.collection-list');
                currentProductsContainer = document.querySelector('#results ul.collection-list');
                if (newProductsContainer && currentProductsContainer) {
                  // Get new products from the response (including promotional tiles)
                  newProducts = newProductsContainer.querySelectorAll('li'); // Append new products to the existing grid
                  newProducts.forEach(function (product) {
                    // Clone the node deeply to preserve all attributes and content
                    var clonedProduct = product.cloneNode(true);
                    currentProductsContainer.appendChild(clonedProduct);
                  });

                  // Update pagination state
                  internalCurrentPage += 1;

                  // Look for pagination information in the hidden pagination component
                  hiddenPagination = doc.querySelector('[style*="display: none"] .pagination');
                  if (hiddenPagination) {
                    // Use the actual Next link (theme-link without --back), not numeric page anchors
                    nextLink = hiddenPagination.querySelector('a.theme-link:not(.theme-link--back)');
                    if (nextLink && nextLink.getAttribute('href')) {
                      _this3.nextUrl = nextLink.getAttribute('href');
                      _this3.hasMore = internalCurrentPage < _this3.totalPages;
                    } else {
                      // No next link found, we've reached the end
                      _this3.hasMore = false;
                    }
                  } else {
                    // Fallback: look for load more button data in the response
                    loadMoreButton = doc.querySelector('[x-data*="LoadMore"]');
                    if (loadMoreButton) {
                      xInitAttr = loadMoreButton.getAttribute('x-init');
                      urlMatch = xInitAttr.match(/init\('([^']+)'/);
                      totalPagesMatch = xInitAttr.match(/,\s*(\d+),\s*(\d+)\)/);
                      if (urlMatch && urlMatch[1] && urlMatch[1] !== 'null' && urlMatch[1] !== '') {
                        _this3.nextUrl = urlMatch[1];
                        _this3.hasMore = internalCurrentPage < _this3.totalPages;
                      } else {
                        _this3.hasMore = false;
                      }

                      // Update total pages if available
                      if (totalPagesMatch) {
                        _this3.totalPages = parseInt(totalPagesMatch[1]);
                      }
                    } else {
                      _this3.hasMore = false;
                    }
                  }

                  // Update button text
                  if (_this3.hasMore) {
                    _this3.updateButtonText();
                  }

                  // Trigger event for any scripts that need to reinitialize for new products
                  _this3.dispatchProductsLoadedEvent();
                } else {
                  console.warn('Could not find product containers in response');
                  _this3.hasMore = false;
                }
                _context.next = 24;
                break;
              case 19:
                _context.prev = 19;
                _context.t0 = _context["catch"](3);
                console.error('Error loading more products:', _context.t0);
                // Show error state
                _this3.buttonText = 'Error loading products. Try again.';
                setTimeout(function () {
                  _this3.updateButtonText();
                }, 3000);
              case 24:
                _context.prev = 24;
                _this3.loading = false;
                return _context.finish(24);
              case 27:
              case "end":
                return _context.stop();
            }
          }, _callee, null, [[3, 19, 24, 27]]);
        }))();
      },
      dispatchProductsLoadedEvent: function dispatchProductsLoadedEvent() {
        var event = new CustomEvent('products:loaded', {
          detail: {
            loadMoreComponent: this,
            currentPage: internalCurrentPage,
            hasMore: this.hasMore
          }
        });
        document.dispatchEvent(event);
      }
    };
  });
});

// Register CollectionFilterTabs custom element (moved from snippet)
var CollectionFilterTabs = /*#__PURE__*/function (_HTMLElement) {
  _inherits(CollectionFilterTabs, _HTMLElement);
  var _super = _createSuper(CollectionFilterTabs);
  function CollectionFilterTabs() {
    var _this4;
    _classCallCheck(this, CollectionFilterTabs);
    _this4 = _super.call(this);
    _this4.sectionId = _this4.getAttribute("section-id");
    _this4.selectionMode = _this4.getAttribute("data-selection-mode") || "multi";
    _this4.activeTags = new Set();
    _this4._bound = false;
    return _this4;
  }
  _createClass(CollectionFilterTabs, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      var _this5 = this;
      queueMicrotask(function () {
        _this5.initActiveStates();
        _this5.bindEvents();
      });
    }
  }, {
    key: "initActiveStates",
    value: function initActiveStates() {
      var _this6 = this;
      var url = new URL(window.location.href);
      var tagParams = url.searchParams.getAll("filter.p.tag");
      var allButton = this.querySelector('.filter-tab-button[data-tag="all"]');
      this.querySelectorAll(".filter-tab-button").forEach(function (btn) {
        btn.classList.remove("is-active");
        btn.setAttribute("aria-pressed", "false");
      });
      this.activeTags.clear();
      if (tagParams.length > 0) {
        tagParams.forEach(function (tag) {
          _this6.activeTags.add(tag);
          var selector = ".filter-tab-button[data-tag=\"".concat(CSS.escape(tag), "\"]");
          var button = _this6.querySelector(selector);
          if (button) {
            button.classList.add("is-active");
            button.setAttribute("aria-pressed", "true");
          }
        });
      } else if (allButton) {
        allButton.classList.add("is-active");
        allButton.setAttribute("aria-pressed", "true");
      }
    }
  }, {
    key: "bindEvents",
    value: function bindEvents() {
      var _this7 = this;
      if (this._bound) return;
      this._bound = true;
      this.querySelectorAll(".filter-tab-button").forEach(function (button) {
        button.addEventListener("click", _this7.onFilterButtonClick.bind(_this7));
      });

      // Sync on section reloads
      document.addEventListener("shopify:section:load", function () {
        _this7.initActiveStates();
      });

      // Sync when theme filterable updates complete
      document.addEventListener("filterable:updated", function () {
        setTimeout(function () {
          return _this7.initActiveStates();
        }, 100);
      });
      window.addEventListener("popstate", function () {
        _this7.initActiveStates();
      });
    }
  }, {
    key: "onFilterButtonClick",
    value: function onFilterButtonClick(event) {
      event.preventDefault();
      var button = event.currentTarget;
      var tagHandle = button.dataset.tag;
      var isAll = tagHandle === "all";
      var allButton = this.querySelector('.filter-tab-button[data-tag="all"]');
      button.style.opacity = "0.6";
      button.style.pointerEvents = "none";
      if (isAll) {
        this.activeTags.clear();
        this.querySelectorAll(".filter-tab-button").forEach(function (btn) {
          btn.classList.remove("is-active");
          btn.setAttribute("aria-pressed", "false");
        });
        button.classList.add("is-active");
        button.setAttribute("aria-pressed", "true");
      } else {
        if (this.selectionMode === "single") {
          // Single selection mode: clear all other tags first
          this.activeTags.clear();
          this.querySelectorAll(".filter-tab-button").forEach(function (btn) {
            btn.classList.remove("is-active");
            btn.setAttribute("aria-pressed", "false");
          });

          // Only add the clicked tag if it wasn't already active
          if (!button.classList.contains("is-active")) {
            this.activeTags.add(tagHandle);
            button.classList.add("is-active");
            button.setAttribute("aria-pressed", "true");
          } else {
            // If clicking the same tag again in single mode, show "all"
            if (allButton) {
              allButton.classList.add("is-active");
              allButton.setAttribute("aria-pressed", "true");
            }
          }
        } else {
          // Multi selection mode (existing behavior)
          if (button.classList.contains("is-active")) {
            this.activeTags["delete"](tagHandle);
            button.classList.remove("is-active");
            button.setAttribute("aria-pressed", "false");
          } else {
            this.activeTags.add(tagHandle);
            button.classList.add("is-active");
            button.setAttribute("aria-pressed", "true");
          }
          if (this.activeTags.size === 0) {
            if (allButton) {
              allButton.classList.add("is-active");
              allButton.setAttribute("aria-pressed", "true");
            }
          } else if (allButton) {
            allButton.classList.remove("is-active");
            allButton.setAttribute("aria-pressed", "false");
          }
        }
      }
      this.applyFilters()["finally"](function () {
        button.style.opacity = "";
        button.style.pointerEvents = "";
      });
    }
  }, {
    key: "applyFilters",
    value: function applyFilters() {
      var _this8 = this;
      return new Promise(function (resolve) {
        var root = document.getElementById("filterable") || document.querySelector('[x-data="Filterable"]');
        var form = document.getElementById("filters-form-sidebar") || document.getElementById("filters-form-filters-drop-down") || document.getElementById("filters-form-drawer");
        if (root && form) {
          var inputs = Array.from(form.querySelectorAll('input[name="filter.p.tag"]'));
          inputs.forEach(function (inp) {
            var val = inp.value;
            var shouldBeActive = _this8.activeTags.has(val);
            if (inp.type === "checkbox" || inp.type === "radio") {
              inp.checked = shouldBeActive;
            }
          });
          _this8.activeTags.forEach(function (tag) {
            var exists = inputs.some(function (inp) {
              return inp.value === tag;
            });
            if (!exists) {
              var hidden = document.createElement("input");
              hidden.type = "hidden";
              hidden.name = "filter.p.tag";
              hidden.value = tag;
              hidden.setAttribute("data-added-by-tabs", "true");
              form.appendChild(hidden);
            }
          });
          form.querySelectorAll('input[name="filter.p.tag"][data-added-by-tabs="true"]').forEach(function (el) {
            if (!_this8.activeTags.has(el.value)) el.remove();
          });
          var submitted = form.dispatchEvent(new Event("submit", {
            bubbles: true,
            cancelable: true
          }));
          if (!submitted && typeof form.requestSubmit === "function") form.requestSubmit();
          setTimeout(function () {
            var modelToggleComponent = document.querySelector("model-toggle");
            if (modelToggleComponent && typeof modelToggleComponent.refresh === "function") {
              modelToggleComponent.refresh();
            }
            resolve();
          }, 350);
        } else {
          var url = _this8.buildFilterUrl();
          window.location.href = url;
          resolve();
        }
      });
    }
  }, {
    key: "buildFilterUrl",
    value: function buildFilterUrl() {
      var url = new URL(window.location.origin + window.location.pathname);
      var currentParams = new URLSearchParams(window.location.search);
      var _iterator = _createForOfIteratorHelper(currentParams.entries()),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var _step$value = _slicedToArray(_step.value, 2),
            key = _step$value[0],
            value = _step$value[1];
          if (!key.startsWith("filter.p.tag") && key !== "page") {
            url.searchParams.append(key, value);
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      this.activeTags.forEach(function (tag) {
        url.searchParams.append("filter.p.tag", tag);
      });
      if (this.sectionId) {
        url.searchParams.set("section_id", this.sectionId);
      }
      return url.toString();
    }
  }]);
  return CollectionFilterTabs;
}( /*#__PURE__*/_wrapNativeSuper(HTMLElement));
customElements.define("collection-filter-tabs", CollectionFilterTabs);

// Define a class for the Swiper component that extends the HTMLElement class
var SwiperComponent = /*#__PURE__*/function (_HTMLElement2) {
  _inherits(SwiperComponent, _HTMLElement2);
  var _super2 = _createSuper(SwiperComponent);
  // The constructor is called when an object is created with the class
  function SwiperComponent() {
    var _this9;
    _classCallCheck(this, SwiperComponent);
    _this9 = _super2.call(this); // Call the parent class constructor
    _this9.swiperInstance = null; // Store the swiper instance
    return _this9;
  }

  // connectedCallback is a lifecycle method that is called when the custom element is first connected to the document's DOM
  _createClass(SwiperComponent, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      var _this10 = this;
      // Use a small delay to ensure DOM is ready
      setTimeout(function () {
        _this10.initSwiper();
      }, 10);

      // Add resize listener to handle responsive behavior
      this.handleResize = this.handleResize.bind(this);
      window.addEventListener('resize', this.handleResize);

      // Add listener for second image toggle events
      this.handleImageToggle = this.handleImageToggle.bind(this);
      document.addEventListener('second-images-toggled', this.handleImageToggle);
    }

    // disconnectedCallback is called when the element is removed from the DOM
  }, {
    key: "disconnectedCallback",
    value: function disconnectedCallback() {
      this.destroySwiper();
      window.removeEventListener('resize', this.handleResize);
      document.removeEventListener('second-images-toggled', this.handleImageToggle);
    }

    // Handle window resize to reinitialize swiper with correct settings
  }, {
    key: "handleResize",
    value: function handleResize() {
      var _this11 = this;
      // Debounce resize events
      clearTimeout(this.resizeTimeout);
      this.resizeTimeout = setTimeout(function () {
        _this11.initSwiper();
      }, 250);
    }

    // Handle image toggle events
  }, {
    key: "handleImageToggle",
    value: function handleImageToggle(event) {
      var showSecondImage = event.detail.showSecondImage;

      // Immediate response without delay to prevent glitching
      if (this.getSlidesCount() > 1) {
        var targetIndex = showSecondImage ? 1 : 0;
        var currentIndex = this.getCurrentSlideIndex();

        // Only update if we're not already on the correct slide
        if (currentIndex !== targetIndex) {
          // Use immediate slide transition (0ms) to prevent visible glitch
          if (this.swiperInstance) {
            this.swiperInstance.slideTo(targetIndex, 0); // 0 = no transition time
          }
        }
      }
    }

    // Method to destroy existing instance
  }, {
    key: "destroySwiper",
    value: function destroySwiper() {
      if (this.swiperInstance) {
        this.swiperInstance.destroy(true, true);
        this.swiperInstance = null;
      }
    }

    // Method to initialize the Swiper
  }, {
    key: "initSwiper",
    value: function initSwiper() {
      var _this12 = this;
      // Store current slide index before destroying the instance
      var currentSlideIndex = this.getCurrentSlideIndex();

      // Destroy existing instance if any
      this.destroySwiper();

      // Find pagination and navigation elements within this swiper instance
      var paginationEl = this.querySelector('.swiper-pagination');
      var nextEl = this.querySelector('.swiper-button-next');
      var prevEl = this.querySelector('.swiper-button-prev');
      var scrollbarEl = this.querySelector('.swiper-scrollbar');

      // Check if touch/swipe should be disabled based on device type
      var disableSwipeMobile = this.hasAttribute('data-disable-swipe-mobile') || this.dataset.disableSwipeMobile === 'true';
      var disableSwipeDesktop = this.hasAttribute('data-disable-swipe-desktop') || this.dataset.disableSwipeDesktop === 'true';

      // Determine if we should disable swipe based on current viewport
      var isMobile = window.innerWidth < 1024; // lg breakpoint
      var disableSwipe = isMobile && disableSwipeMobile || !isMobile && disableSwipeDesktop;

      // Define the options for the Swiper
      var swiperOptions = {
        slidesPerView: 1,
        // Number of slides per view
        spaceBetween: 1,
        // Space between slides
        navigation: {
          nextEl: nextEl,
          prevEl: prevEl
        },
        pagination: {
          el: paginationEl,
          clickable: true,
          dynamicBullets: false,
          renderBullet: function renderBullet(index, className) {
            return '<span class="' + className + '"></span>';
          }
        },
        scrollbar: {
          el: scrollbarEl,
          draggable: !disableSwipe // Disable scrollbar dragging if swipe is disabled
        },

        // Conditionally disable touch/swipe functionality
        allowTouchMove: !disableSwipe,
        simulateTouch: !disableSwipe,
        touchStartPreventDefault: disableSwipe ? false : true,
        // Add observer to handle dynamic content changes
        observer: true,
        observeParents: true,
        // Update pagination on slide change
        on: {
          slideChange: function slideChange() {
            // Force pagination update
            if (this.pagination && this.pagination.render) {
              this.pagination.render();
              this.pagination.update();
            }
          }
        }
      };

      // Initialize the Swiper with the options and store the instance
      this.swiperInstance = new Swiper(this, swiperOptions);

      // Restore the previous slide position or check toggle state immediately
      // Check if the show model toggle is currently active
      var checkbox = document.querySelector('.floating-image-toggle input[type="checkbox"]');
      var isToggleActive = checkbox && checkbox.checked;
      if (isToggleActive && this.swiperInstance && this.swiperInstance.slides.length > 1) {
        // If toggle is active, go to second slide immediately
        this.swiperInstance.slideTo(1, 0); // 0 for instant transition
      } else if (currentSlideIndex > 0 && this.swiperInstance && this.swiperInstance.slides.length > currentSlideIndex) {
        // Otherwise restore the previous slide position immediately
        this.swiperInstance.slideTo(currentSlideIndex, 0); // 0 for instant transition
      }

      // Force pagination update after a brief moment to let swiper settle
      setTimeout(function () {
        if (_this12.swiperInstance && _this12.swiperInstance.pagination) {
          _this12.swiperInstance.pagination.render();
          _this12.swiperInstance.pagination.update();
        }
      }, 10);
    }

    // Method to go to specific slide
  }, {
    key: "goToSlide",
    value: function goToSlide(slideIndex) {
      var _this13 = this;
      if (this.swiperInstance && this.swiperInstance.slides.length > slideIndex) {
        this.swiperInstance.slideTo(slideIndex);
        // Update pagination after slide change
        setTimeout(function () {
          _this13.updatePagination();
        }, 100);
      }
    }

    // Method to get current slide index
  }, {
    key: "getCurrentSlideIndex",
    value: function getCurrentSlideIndex() {
      return this.swiperInstance ? this.swiperInstance.activeIndex : 0;
    }

    // Method to get total number of slides
  }, {
    key: "getSlidesCount",
    value: function getSlidesCount() {
      return this.swiperInstance ? this.swiperInstance.slides.length : 0;
    }

    // Method to force pagination update
  }, {
    key: "updatePagination",
    value: function updatePagination() {
      if (this.swiperInstance && this.swiperInstance.pagination) {
        this.swiperInstance.pagination.render();
        this.swiperInstance.pagination.update();
      }
    }

    // Method to update swiper (useful for dynamic content changes)
  }, {
    key: "updateSwiper",
    value: function updateSwiper() {
      if (this.swiperInstance) {
        this.swiperInstance.update();
        this.updatePagination();
      }
    }
  }]);
  return SwiperComponent;
}( /*#__PURE__*/_wrapNativeSuper(HTMLElement)); // Define the custom element
customElements.define("products-swiper-component", SwiperComponent);

// Global function to toggle all swiper components between first and second images
window.toggleSecondImages = function (showSecondImage) {
  // Just dispatch the event - let individual swipers handle themselves
  // This prevents multiple competing calls to the same swiper
  document.dispatchEvent(new CustomEvent('second-images-toggled', {
    detail: {
      showSecondImage: showSecondImage
    }
  }));
};

// Global function to update all swiper pagination
window.updateAllSwiperPagination = function () {
  var swiperComponents = document.querySelectorAll('products-swiper-component');
  swiperComponents.forEach(function (swiper) {
    if (swiper.updatePagination) {
      swiper.updatePagination();
    }
  });
};

// Also handle the case when new products are loaded via AJAX (Load More functionality)
document.addEventListener('products:loaded', function () {
  // Check current toggle state and apply to newly loaded products
  var checkbox = document.querySelector('.floating-image-toggle input[type="checkbox"]');
  if (checkbox && checkbox.checked) {
    setTimeout(function () {
      window.toggleSecondImages(true);
    }, 200);
  }

  // Update swiper pagination for newly loaded products
  setTimeout(function () {
    window.updateAllSwiperPagination();
  }, 300);
});

// Handle filterable updates (when filters/sorting is applied)
document.addEventListener('filterable:updated', function () {
  // Check current toggle state and apply to filtered products
  var checkbox = document.querySelector('.floating-image-toggle input[type="checkbox"]');
  if (checkbox && checkbox.checked) {
    setTimeout(function () {
      window.toggleSecondImages(true);
    }, 300);
  }

  // Update swiper pagination after filtering
  setTimeout(function () {
    window.updateAllSwiperPagination();
  }, 400);
});

// Listen for theme:variant:change event
document.addEventListener('theme:variant:change', /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(event) {
    var _event$detail, _event$detail$variant, _event$detail2, _event$detail2$produc, _event$detail3, _event$detail3$previo;
    var variantId, productId, previousVariantId, previousVariantHasAlternativeImages, currentVariantHasAlternativeImages, currentUrl, response, html, parser, doc, newMediaContainer, currentMediaContainer, zoomModalContainer, modalsPopup, modalElement, zoomUrl, zoomResponse, zoomHtml, zoomDoc, newZoomContent, newModalsPopup, clearedUrls;
    return _regeneratorRuntime().wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          console.log('Gallery variadnt changed:', event.detail);
          // Handle gallery variant change here
          variantId = (_event$detail = event.detail) === null || _event$detail === void 0 ? void 0 : (_event$detail$variant = _event$detail.variant) === null || _event$detail$variant === void 0 ? void 0 : _event$detail$variant.id;
          productId = (_event$detail2 = event.detail) === null || _event$detail2 === void 0 ? void 0 : (_event$detail2$produc = _event$detail2.product) === null || _event$detail2$produc === void 0 ? void 0 : _event$detail2$produc.id;
          previousVariantId = (_event$detail3 = event.detail) === null || _event$detail3 === void 0 ? void 0 : (_event$detail3$previo = _event$detail3.previousVariant) === null || _event$detail3$previo === void 0 ? void 0 : _event$detail3$previo.id;
          if (variantId) {
            _context2.next = 6;
            break;
          }
          return _context2.abrupt("return");
        case 6:
          if (!(previousVariantId == null)) {
            _context2.next = 8;
            break;
          }
          return _context2.abrupt("return");
        case 8:
          // check if the previousVariant and the new variant use the default media
          previousVariantHasAlternativeImages = window.variantAlternativeImages && window.variantAlternativeImages[previousVariantId];
          currentVariantHasAlternativeImages = window.variantAlternativeImages && window.variantAlternativeImages[variantId]; // If both variants use default media (no alternative images), skip gallery update
          if (!(!previousVariantHasAlternativeImages && !currentVariantHasAlternativeImages)) {
            _context2.next = 12;
            break;
          }
          return _context2.abrupt("return");
        case 12:
          _context2.prev = 12;
          currentUrl = new URL(window.location.href);
          currentUrl.searchParams.set('variant', variantId);
          _context2.next = 17;
          return fetch(currentUrl.toString());
        case 17:
          response = _context2.sent;
          if (response.ok) {
            _context2.next = 20;
            break;
          }
          throw new Error("HTTP error! status: ".concat(response.status));
        case 20:
          _context2.next = 22;
          return response.text();
        case 22:
          html = _context2.sent;
          parser = new DOMParser();
          doc = parser.parseFromString(html, 'text/html');
          newMediaContainer = doc.querySelector('div[data-product-media-container]');
          currentMediaContainer = document.querySelector('div[data-product-media-container]');
          if (newMediaContainer && currentMediaContainer) {
            currentMediaContainer.innerHTML = newMediaContainer.innerHTML;

            // Reinitialize any scripts or components that might be needed for the new media
            document.dispatchEvent(new CustomEvent("theme:gallery:reinit", {
              detail: {
                productId: productId
              }
            }));
          }

          // Update zoom modal content if it's open
          zoomModalContainer = document.querySelector('#main-zoom');
          modalsPopup = document.querySelector('#modals-popup');
          if (!zoomModalContainer) {
            _context2.next = 45;
            break;
          }
          // Check if zoom modal is currently visible
          modalElement = zoomModalContainer.closest('[data-modal-label]');
          if (!modalElement) {
            _context2.next = 45;
            break;
          }
          // Get the zoom section URL with the new variant
          zoomUrl = currentUrl.toString().replace(window.location.search, '') + "?variant=".concat(variantId, "&section_id=main-product-zoom"); // Try to use the theme's fetchedFragment method if available
          if (window.Alpine && Alpine.store && Alpine.store.fetchedFragments) {
            // Clear the cached fragment for this URL
            delete Alpine.store.fetchedFragments[zoomUrl];
          }

          // Update the zoom content by fetching new section
          _context2.next = 37;
          return fetch(zoomUrl);
        case 37:
          zoomResponse = _context2.sent;
          if (!zoomResponse.ok) {
            _context2.next = 45;
            break;
          }
          _context2.next = 41;
          return zoomResponse.text();
        case 41:
          zoomHtml = _context2.sent;
          zoomDoc = parser.parseFromString(zoomHtml, 'text/html');
          newZoomContent = zoomDoc.querySelector('.product-zoom');
          if (newZoomContent) {
            // Replace the entire zoom container to ensure proper Alpine.js reinitialization
            zoomModalContainer.outerHTML = newZoomContent.outerHTML;

            // Also update modals-popup content if it exists
            if (modalsPopup) {
              newModalsPopup = zoomDoc.querySelector('#modals-popup');
              if (newModalsPopup) {
                modalsPopup.innerHTML = newModalsPopup.innerHTML;
              }
            }

            // Dispatch event to reinitialize zoom functionality
            document.dispatchEvent(new CustomEvent("theme:zoom:reinit", {
              detail: {
                variantId: variantId,
                productId: productId
              }
            }));
          }
        case 45:
          // Clear zoom fragment cache for future opens
          if (window.Alpine && Alpine.store && Alpine.store.fetchedFragments) {
            // Clear any cached zoom fragments so they'll be refetched with new variant
            clearedUrls = [];
            Object.keys(Alpine.store.fetchedFragments).forEach(function (url) {
              if (url.includes('section_id=main-product-zoom')) {
                delete Alpine.store.fetchedFragments[url];
                clearedUrls.push(url);
              }
            });
            console.log('Cleared zoom fragment cache for URLs:', clearedUrls);
          }
          _context2.next = 51;
          break;
        case 48:
          _context2.prev = 48;
          _context2.t0 = _context2["catch"](12);
          console.error('Error fetching variant media:', _context2.t0);
        case 51:
        case "end":
          return _context2.stop();
      }
    }, _callee2, null, [[12, 48]]);
  }));
  return function (_x2) {
    return _ref.apply(this, arguments);
  };
}());

// Listen for zoom reinit event to handle component reinitialization
document.addEventListener('theme:zoom:reinit', function (event) {
  console.log('Zoom reinit event triggered:', event.detail);

  // Wait a bit for Alpine.js to process the new DOM
  setTimeout(function () {
    var zoomContainer = document.querySelector('#main-zoom');
    if (zoomContainer) {
      // Dispatch Alpine.js refresh event to ensure proper initialization
      zoomContainer.dispatchEvent(new CustomEvent('alpine:reinit'));
    }
  }, 100);
});

// Handle sibling product selection with AJAX
document.addEventListener('DOMContentLoaded', function () {
  // Handle sibling product clicks (combined handler to prevent double execution)
  document.addEventListener('click', function (event) {
    // Only handle actual link clicks, not button clicks
    // Check if the clicked element is a button (dropdown trigger)
    if (event.target.closest('button[x-ref="button"]') || event.target.tagName === 'BUTTON') {
      return; // Don't handle button clicks, let Alpine.js handle dropdown functionality
    }

    // Check for dropdown sibling links first (more specific)
    var dropdownLink = event.target.closest('a[data-sibling-product="true"]');
    if (dropdownLink) {
      event.preventDefault();

      // Close the dropdown if it's open
      var dropdown = dropdownLink.closest('[x-data="VariantDropDown"]');
      if (dropdown) {
        // Trigger Alpine.js close method
        var button = dropdown.querySelector('button[x-ref="button"]');
        if (button) {
          button.dispatchEvent(new Event('click'));
        }
      }
      loadSiblingProduct(dropdownLink.href);
      return; // Exit early to prevent the second condition from running
    }

    // Check for general sibling product links
    var siblingLink = event.target.closest('a[href*="/products/"]:not([data-direct-nav])');

    // Check if this is within a sibling products section
    var isInSiblingSection = siblingLink && (siblingLink.closest('.product-siblings-section') || siblingLink.closest('.product-swatch--items-container'));
    if (isInSiblingSection) {
      event.preventDefault();
      loadSiblingProduct(siblingLink.href);
    }
  });
});
function loadSiblingProduct(_x3) {
  return _loadSiblingProduct.apply(this, arguments);
}
function _loadSiblingProduct() {
  _loadSiblingProduct = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(productUrl) {
    var mainContent, loadingOverlay, response, html, parser, doc, newMainContent;
    return _regeneratorRuntime().wrap(function _callee3$(_context3) {
      while (1) switch (_context3.prev = _context3.next) {
        case 0:
          mainContent = document.getElementById('MainContent');
          if (mainContent) {
            _context3.next = 5;
            break;
          }
          console.warn('MainContent element not found, falling back to direct navigation');
          window.location.href = productUrl;
          return _context3.abrupt("return");
        case 5:
          // Show loading state
          loadingOverlay = createLoadingOverlay();
          mainContent.style.position = 'relative';
          mainContent.appendChild(loadingOverlay);
          _context3.prev = 8;
          // Add loading class to prevent interactions
          mainContent.classList.add('loading-sibling-product');
          _context3.next = 12;
          return fetch(productUrl);
        case 12:
          response = _context3.sent;
          if (response.ok) {
            _context3.next = 15;
            break;
          }
          throw new Error("HTTP error! status: ".concat(response.status));
        case 15:
          _context3.next = 17;
          return response.text();
        case 17:
          html = _context3.sent;
          parser = new DOMParser();
          doc = parser.parseFromString(html, 'text/html'); // Extract the new main content
          newMainContent = doc.getElementById('MainContent');
          if (newMainContent) {
            _context3.next = 23;
            break;
          }
          throw new Error('MainContent not found in response');
        case 23:
          // Update the main content
          mainContent.innerHTML = newMainContent.innerHTML;

          //Extract the new Zoom content
          // const newZoomContent = doc.getElementById('modals-modal');

          // debugger;
          // if (!newZoomContent) {
          //   throw new Error('Zoom content not found in response');
          // }
          // const currentZoomContent = document.querySelector('#modals-modal');
          // if (currentZoomContent) {
          //   currentZoomContent.innerHTML = newZoomContent.innerHTML;
          // }
          // Update the page URL without triggering navigation
          // window.history.pushState(
          //   { siblingProductLoad: true }, 
          //   doc.title || document.title,
          //   productUrl
          // );

          // Update page title
          if (doc.title) {
            document.title = doc.title;
          }

          // Reinitialize content
          // await reinitializeSiblingContent(mainContent);

          // Scroll to top of main content smoothly
          mainContent.scrollIntoView({
            behavior: 'smooth',
            block: 'start'
          });

          // Dispatch custom event for any components that need to know about the update
          // document.dispatchEvent(new CustomEvent('sibling:product:loaded', {
          //   detail: { 
          //     productUrl: productUrl,
          //     mainContent: mainContent
          //   }
          // }));
          _context3.next = 33;
          break;
        case 28:
          _context3.prev = 28;
          _context3.t0 = _context3["catch"](8);
          console.error('Error loading sibling product:', _context3.t0);

          // Show error message briefly then fallback to direct navigation
          showErrorMessage('Error loading product. Redirecting...');
          setTimeout(function () {
            window.location.href = productUrl;
          }, 1500);
        case 33:
          _context3.prev = 33;
          // Remove loading state
          mainContent.classList.remove('loading-sibling-product');
          if (loadingOverlay && loadingOverlay.parentNode) {
            loadingOverlay.remove();
          }
          mainContent.style.position = '';
          return _context3.finish(33);
        case 38:
        case "end":
          return _context3.stop();
      }
    }, _callee3, null, [[8, 28, 33, 38]]);
  }));
  return _loadSiblingProduct.apply(this, arguments);
}
function createLoadingOverlay() {
  var overlay = document.createElement('div');
  overlay.className = 'sibling-loading-overlay';
  overlay.style.cssText = "\n    position: absolute;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    background: rgba(255, 255, 255, 0.3);\n    z-index: 1000;\n  ";
  return overlay;
}
function showErrorMessage(message) {
  var errorDiv = document.createElement('div');
  errorDiv.style.cssText = "\n    position: fixed;\n    top: 20px;\n    right: 20px;\n    background: #ff4444;\n    color: white;\n    padding: 12px 20px;\n    border-radius: 4px;\n    z-index: 10000;\n    font-size: 14px;\n  ";
  errorDiv.textContent = message;
  document.body.appendChild(errorDiv);
  setTimeout(function () {
    if (errorDiv.parentNode) {
      errorDiv.remove();
    }
  }, 3000);
}
function reinitializeSiblingContent(_x4) {
  return _reinitializeSiblingContent.apply(this, arguments);
} // Handle browser back/forward navigation
// window.addEventListener('popstate', function(event) {
//   if (event.state && event.state.siblingProductLoad) {
//     // Reload the page to ensure proper state
//     window.location.reload();
//   }
// });
// Handle links containing "DISCUSS" or "discuss" on page load
function _reinitializeSiblingContent() {
  _reinitializeSiblingContent = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4(container) {
    var alpineElements, swiperComponents, otherCustomElements;
    return _regeneratorRuntime().wrap(function _callee4$(_context4) {
      while (1) switch (_context4.prev = _context4.next) {
        case 0:
          _context4.next = 2;
          return new Promise(function (resolve) {
            return setTimeout(resolve, 50);
          });
        case 2:
          try {
            // Reinitialize Alpine.js components
            if (window.Alpine) {
              // Find and initialize any Alpine components in the new content
              alpineElements = container.querySelectorAll('[x-data]');
              alpineElements.forEach(function (element) {
                if (!element._x_dataStack) {
                  window.Alpine.initTree(element);
                }
              });
            }

            // Reinitialize Swiper components first
            swiperComponents = container.querySelectorAll('products-swiper-component');
            swiperComponents.forEach(function (swiperComponent) {
              if (swiperComponent.initSwiper) {
                swiperComponent.initSwiper();
              }
            });

            // Reinitialize other custom elements
            otherCustomElements = container.querySelectorAll('collection-filter-tabs');
            otherCustomElements.forEach(function (element) {
              if (element.connectedCallback) {
                element.connectedCallback();
              }
            });

            // Dispatch single gallery reinit event (this will handle all necessary reinitialization)
            document.dispatchEvent(new CustomEvent("theme:gallery:reinit", {
              detail: {
                container: container
              }
            }));

            // Clear any cached zoom fragments for the new product
            if (window.Alpine && Alpine.store && Alpine.store.fetchedFragments) {
              Object.keys(Alpine.store.fetchedFragments).forEach(function (url) {
                if (url.includes('section_id=main-product-zoom')) {
                  delete Alpine.store.fetchedFragments[url];
                }
              });
            }

            // Update all swiper pagination after reinitialization
            setTimeout(function () {
              window.updateAllSwiperPagination();
            }, 200);
            console.log('Sibling content reinitialized successfully');
          } catch (error) {
            console.error('Error reinitializing sibling content:', error);
          }
        case 3:
        case "end":
          return _context4.stop();
      }
    }, _callee4);
  }));
  return _reinitializeSiblingContent.apply(this, arguments);
}
document.addEventListener('DOMContentLoaded', function () {
  // Find all anchor tags that contain "DISCUSS" or "discuss" in their text content or href
  var discussLinks = document.querySelectorAll('a');
  var filteredDiscussLinks = Array.from(discussLinks).filter(function (link) {
    var linkText = link.textContent.toLowerCase();
    var linkHref = link.href.toLowerCase();
    var linkClass = link.className.toLowerCase();
    return linkText.includes('discuss') || linkHref.includes('discuss') || linkText.includes('chat') || linkHref.includes('chat') || linkClass.includes('chat-trigger');
  });

  // Handle each discuss link
  filteredDiscussLinks.forEach(function (link) {
    console.log('Found discuss link:', link);

    // Add event listener for discuss links
    link.addEventListener('click', function (event) {
      event.preventDefault();
      // Your custom handling code here
      var button = document.querySelector('.globo-formbuilder .floating-button');
      if (button) {
        button.click();
      }
    });
  });
});

/***/ }),

/***/ "./src/scss/main.scss":
/*!****************************!*\
  !*** ./src/scss/main.scss ***!
  \****************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
// extracted by mini-css-extract-plugin


/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId](module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = __webpack_modules__;
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/chunk loaded */
/******/ 	(() => {
/******/ 		var deferred = [];
/******/ 		__webpack_require__.O = (result, chunkIds, fn, priority) => {
/******/ 			if(chunkIds) {
/******/ 				priority = priority || 0;
/******/ 				for(var i = deferred.length; i > 0 && deferred[i - 1][2] > priority; i--) deferred[i] = deferred[i - 1];
/******/ 				deferred[i] = [chunkIds, fn, priority];
/******/ 				return;
/******/ 			}
/******/ 			var notFulfilled = Infinity;
/******/ 			for (var i = 0; i < deferred.length; i++) {
/******/ 				var [chunkIds, fn, priority] = deferred[i];
/******/ 				var fulfilled = true;
/******/ 				for (var j = 0; j < chunkIds.length; j++) {
/******/ 					if ((priority & 1 === 0 || notFulfilled >= priority) && Object.keys(__webpack_require__.O).every((key) => (__webpack_require__.O[key](chunkIds[j])))) {
/******/ 						chunkIds.splice(j--, 1);
/******/ 					} else {
/******/ 						fulfilled = false;
/******/ 						if(priority < notFulfilled) notFulfilled = priority;
/******/ 					}
/******/ 				}
/******/ 				if(fulfilled) {
/******/ 					deferred.splice(i--, 1)
/******/ 					var r = fn();
/******/ 					if (r !== undefined) result = r;
/******/ 				}
/******/ 			}
/******/ 			return result;
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	(() => {
/******/ 		__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	(() => {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = (exports) => {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/jsonp chunk loading */
/******/ 	(() => {
/******/ 		// no baseURI
/******/ 		
/******/ 		// object to store loaded and loading chunks
/******/ 		// undefined = chunk not loaded, null = chunk preloaded/prefetched
/******/ 		// [resolve, reject, Promise] = chunk loading, 0 = chunk loaded
/******/ 		var installedChunks = {
/******/ 			"/assets/main": 0,
/******/ 			"assets/main": 0
/******/ 		};
/******/ 		
/******/ 		// no chunk on demand loading
/******/ 		
/******/ 		// no prefetching
/******/ 		
/******/ 		// no preloaded
/******/ 		
/******/ 		// no HMR
/******/ 		
/******/ 		// no HMR manifest
/******/ 		
/******/ 		__webpack_require__.O.j = (chunkId) => (installedChunks[chunkId] === 0);
/******/ 		
/******/ 		// install a JSONP callback for chunk loading
/******/ 		var webpackJsonpCallback = (parentChunkLoadingFunction, data) => {
/******/ 			var [chunkIds, moreModules, runtime] = data;
/******/ 			// add "moreModules" to the modules object,
/******/ 			// then flag all "chunkIds" as loaded and fire callback
/******/ 			var moduleId, chunkId, i = 0;
/******/ 			if(chunkIds.some((id) => (installedChunks[id] !== 0))) {
/******/ 				for(moduleId in moreModules) {
/******/ 					if(__webpack_require__.o(moreModules, moduleId)) {
/******/ 						__webpack_require__.m[moduleId] = moreModules[moduleId];
/******/ 					}
/******/ 				}
/******/ 				if(runtime) var result = runtime(__webpack_require__);
/******/ 			}
/******/ 			if(parentChunkLoadingFunction) parentChunkLoadingFunction(data);
/******/ 			for(;i < chunkIds.length; i++) {
/******/ 				chunkId = chunkIds[i];
/******/ 				if(__webpack_require__.o(installedChunks, chunkId) && installedChunks[chunkId]) {
/******/ 					installedChunks[chunkId][0]();
/******/ 				}
/******/ 				installedChunks[chunkId] = 0;
/******/ 			}
/******/ 			return __webpack_require__.O(result);
/******/ 		}
/******/ 		
/******/ 		var chunkLoadingGlobal = self["webpackChunk"] = self["webpackChunk"] || [];
/******/ 		chunkLoadingGlobal.forEach(webpackJsonpCallback.bind(null, 0));
/******/ 		chunkLoadingGlobal.push = webpackJsonpCallback.bind(null, chunkLoadingGlobal.push.bind(chunkLoadingGlobal));
/******/ 	})();
/******/ 	
/************************************************************************/
/******/ 	
/******/ 	// startup
/******/ 	// Load entry module and return exports
/******/ 	// This entry module depends on other loaded chunks and execution need to be delayed
/******/ 	__webpack_require__.O(undefined, ["assets/main"], () => (__webpack_require__("./src/js/main.js")))
/******/ 	var __webpack_exports__ = __webpack_require__.O(undefined, ["assets/main"], () => (__webpack_require__("./src/scss/main.scss")))
/******/ 	__webpack_exports__ = __webpack_require__.O(__webpack_exports__);
/******/ 	
/******/ })()
;